import MaskAndValid from "utils/maskAndValid";

export function collectGruposEconomicosFromRepresentative(representative) {
  const list = representative?.GruposEconomicos;
  if (Array.isArray(list) && list.length > 0) {
    return list.map((g) => ({
      Id: g.Id ?? g.id,
      Nome: g.Nome ?? g.nome,
    }));
  }
  const gid = representative?.IdGrupoEconomico;
  const gnome = representative?.GrupoEconomico;
  if (gid != null && gnome) {
    return [{ Id: gid, Nome: gnome }];
  }
  return [];
}

export function formatRepresentativeLabel(item) {
  const rawCnpj =
    item?.CnpjCpf ||
    item?.Cnpj ||
    item?.CnpjCpfPessoa ||
    item?.CNPJ ||
    "";
  const cnpj = rawCnpj ? MaskAndValid.maskCNPJ(String(rawCnpj)) : "";
  const nome = (item?.Nome || item?.RazaoSocial || "").trim();
  if (cnpj && nome) return `${cnpj} - ${nome}`;
  return nome || cnpj || "";
}

export const DEFAULT_REPRESENTATIVE_LIST_FILTERS = {
  status: { id: "TODOS", value: "TODOS", label: "Todos" },
  region: null,
  grupoEconomico: null,
  razaoSocial: null,
  cnpj: "",
  search: "",
};

export const REPRESENTATIVE_PAGE_SIZE = 25;

/** Limite de itens em «selecionar todos os resultados» (representantes / clientes). */
export const SELECT_ALL_REPRESENTATIVES_MAX = 2000;

export function representativeMatchesGrupoEconomico(representative, grupoOption) {
  const grupoValue = grupoOption?.Id ?? grupoOption?.Nome ?? "";
  if (!grupoValue) return true;
  const idWanted = grupoOption?.Id;
  const nomeWanted = (grupoOption?.Nome || "").toLowerCase();
  return collectGruposEconomicosFromRepresentative(representative).some(
    (g) =>
      (idWanted != null && g.Id === idWanted) ||
      (nomeWanted && (g.Nome || "").toLowerCase() === nomeWanted),
  );
}

/** Filtro client-side (legado); listagens paginadas usam API. */
export function filterRepresentatives(list, filters) {
  const cnpjDigits = (value) => (value || "").replace(/\D/g, "");

  return list.filter((representative) => {
    const matchStatus =
      !filters?.status?.value ||
      filters.status.value === "TODOS" ||
      (representative.Status || "").toUpperCase() ===
        String(filters.status.value).toUpperCase();

    const matchRegion =
      !filters?.region?.value ||
      (representative.Estado ||
        representative.Regiao ||
        representative.EndPrincipalUf ||
        "")
        .toUpperCase()
        .includes(String(filters.region.value).toUpperCase());

    const matchSearch =
      !filters?.search?.trim() ||
      formatRepresentativeLabel(representative)
        .toLowerCase()
        .includes(filters.search.toLowerCase());

    const matchGrupoEconomico = representativeMatchesGrupoEconomico(
      representative,
      filters.grupoEconomico,
    );

    const razaoValue =
      filters?.razaoSocial?.Id ?? filters?.razaoSocial?.Nome ?? "";
    const matchRazaoSocial =
      !razaoValue ||
      representative.IdPessoaLoja === filters.razaoSocial?.Id ||
      (representative.RazaoSocial || representative.Nome || "")
        .toLowerCase()
        .includes((filters.razaoSocial?.Nome || "").toLowerCase());

    const matchCnpj =
      !filters?.cnpj?.trim() ||
      cnpjDigits(
        representative.CnpjCpf ||
          representative.Cnpj ||
          representative.CnpjCpfPessoa ||
          representative.CNPJ,
      ).includes(cnpjDigits(filters.cnpj));

    return (
      matchStatus &&
      matchRegion &&
      matchSearch &&
      matchGrupoEconomico &&
      matchRazaoSocial &&
      matchCnpj
    );
  });
}
